<div fxLayout="row" class="loading-bar" [ngClass]="{'is-hidden' : !(showBar$ | async)}">
  <mat-progress-bar *ngIf="showBar$ | async"
                    [mode]="mode"></mat-progress-bar>
</div>
